exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WebAppLink{display:-webkit-box;display:-ms-flexbox;display:flex}@media only screen and (max-width: 620px){.WebAppLink{width:288px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.WebAppLink-Main{-webkit-margin-start:32px;margin-inline-start:32px}@media only screen and (max-width: 620px){.WebAppLink-Main{-webkit-margin-start:0px;margin-inline-start:0px}}.WebAppLink-header{font-size:20px;font-weight:500;margin-bottom:4px}.WebAppLink-subheader{font-size:14px;font-weight:400;margin-bottom:48px}", ""]);

// exports
